export default "__VITE_ASSET__TcMkHxPn__"